module.exports = __webpack_public_path__ + "img/oil-pressure.cdc97ee2.svg";